/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sdh_Removal_CompleteInputs */



/**
* | output |
* | --- |
* | "SDH removal process complete" |
*
* @param {Sdh_Removal_CompleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const sdh_removal_complete = /** @type {((inputs?: Sdh_Removal_CompleteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sdh_Removal_CompleteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Suppression SDH terminée")
	if (locale === "de") return /** @type {LocalizedString} */ ("SDH-Entfernungsprozess abgeschlossen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Completamento del processo di rimozione SDH")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Процесс удаления SDH завершен.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Proceso de eliminación de SDH completado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("SDH清除过程已完成")
	if (locale === "ja") return /** @type {LocalizedString} */ ("SDH削除プロセスが完了しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एसडीएच हटाने की प्रक्रिया पूरी हो गई है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Processo de remoção de SDH concluído")
	return /** @type {LocalizedString} */ ("SDH removal process complete")
});